import React, { useEffect, useRef, useState, ChangeEvent } from "react";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { PICKLIST_GROUP_NAME, WEB_ROLE } from "../../../../common/Constant";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import Loader from "../../../../common/Loader";
import Snackbar from "../../../../common/Snackbar";
import {
  formatDateTime,
  formatAppointmentDateTime,
} from "../../../../utils/dateUtils";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import NumberInput from "../../../../common/NumberInput";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import ChangeLogDrawer from "../../../Master/Billing/components/Configuration/ChangeLogDrawer";
import { BILLINGCASE_CONFIG_CHANGE_LOG } from "../../../Master/Billing/actions/constant";
import BillingDataTable from "../../../Master/Billing/components/BillingDataTable";
import ThresholdEditableTable from "../../../Master/Billing/components/Configuration/PageThresholdEditable";
import ThresholdLineEditable from "../../../Master/Billing/components/Configuration/LineThresholdEditable";
import {
  updateCaseLevelBillingConfig,
  addCaseLevelBillingConfig,
  getCaseLevelBillingDetails,
  fetchUerListByTenantID,
  getCaseLevelBillingChangeLog,
  fetchUerListByTeam,
  fetchUerListByCase,
} from "../../../../services/BillingConfigApi";
import { setBillingAvailable } from "../../../../redux/slice/CaseHeaderSlice";
import { fetcheaderinfo } from "../../../../services/UserRegistrationApi";

interface UserOptiopn {
  userId?: number;
  usfUlNameRole?: string;
}

const CaseBillingAddConfiguration = ({
  caseUserData,
  onClose,
  onCancel,
  selectedData,
  onTabChange,
  isRowActionTriggered,
  billingActiveTab,
}: any) => {
  const dispatch = useDispatch();
  const userID = useSelector((state: RootState) => state.auth.userid);
  const { isBillingAvailable } = useSelector(
    (state: RootState) => state.caseHeader,
  );
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [rateType, setRateType] = useState("Fixed");
  const [currencyOptions, setCurrencyOptions] = useState<any[]>([]);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [selectedCurrencyLabel, setSelectedCurrencyLabel] = useState("USD");
  const [fixedAmount, setFixedAmount] = useState("");
  const [isInputPages, setIsInputPages] = useState<any>("Input");
  const [thresholdPageData, setThresholdPageData] = useState<any[]>([]);
  const [thresholdLineData, setThresholdLineData] = useState<any[]>([]);
  const [thresholdLineErrors, setThresholdLineErrors] = useState<string[]>([]);
  const caseDetails = useSelector((state: RootState) => state.caseHeader);
  const selectedCaseInfoId = caseDetails?.caseInfoId;
  const [userData, setUserData] = useState<UserOptiopn[]>([]);
  const [userSearchQuery, setUserSearchQuery] = useState<string>("");

  const [thresholdErrors, setThresholdErrors] = useState<string[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [changeLogData, setChangeLogData] = useState<any[]>([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showChangeDrawer, setShowChangeDrawer] = useState(false);
  const [configurationBillingKey, setConfigurationBillingKey] = useState<
    string | null
  >("0");
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [selectedUserName, setSelectedUserName] = useState("");

  const [createdOn, setCreatedOn] = useState("");
  const [createdBy, setCreatedBy] = useState("");

  const [resetKey, setResetKey] = useState(0);
  const isEditMode = Boolean(selectedData?.billingConfigId);
  const formattedStringPerPage = thresholdPageData
    .map((d) => `${d.isInputPage},${d.min},${d.max},${d.rate}`)
    .join(" | ");

  const formattedStringPerLine = thresholdLineData
    .map((d) => `${d.min},${d.max},${d.rate}`)
    .join(" | ");

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={configurationBillingKey}
      onSelect={(key) => setConfigurationBillingKey(key as string)}
    />
  );

  const [pageThresholdKey, setPageThresholdKey] = useState<string | null>("0");

  const handleAccordionSelect = (key: string | null) => {
    if (configurationBillingKey === key) {
      return;
    }
    setConfigurationBillingKey(key || "0");
  };
  const handleRateTypeChange = (
    newType:
      | "Fixed"
      | "Fixed Per Page"
      | "Fixed Per Line"
      | "Per Page"
      | "Per Line",
  ) => {
    setRateType(newType);

    if (!isEditMode) {
      setFixedAmount("");
      setIsInputPages("Output");
      setThresholdPageData([]);
      setThresholdLineData([]);
      setThresholdErrors([]);
      setThresholdLineErrors([]);
      setResetKey((k) => k + 1);
      return;
    }

    if (!billingSnapshot) return;

    setFixedAmount("");
    setThresholdPageData([]);
    setThresholdLineData([]);

    if (newType === "Fixed") {
      setFixedAmount(billingSnapshot.fixedAmount ?? "");
    }

    if (newType === "Fixed Per Page") {
      setFixedAmount(billingSnapshot.pageAmount ?? "");
    }
    if (newType === "Fixed Per Line") {
      setFixedAmount(billingSnapshot.lineAmount ?? "");
    }

    if (newType === "Per Page") {
      setIsInputPages(billingSnapshot.pageType);
      setThresholdPageData(billingSnapshot.pageSlabs);
    }

    if (newType === "Per Line") {
      setThresholdLineData(billingSnapshot.lineSlabs);
    }

    setResetKey((k) => k + 1);
  };

  const handlePagesTypeChange = (newPageType: any) => {
    setIsInputPages(newPageType);

    if (!isEditMode) {
      setThresholdPageData([]);
      setThresholdErrors([]);
      setResetKey((k) => k + 1);
      return;
    }

    if (!billingSnapshot) return;

    setThresholdPageData([]);

    if (newPageType === billingSnapshot.pageType) {
      setThresholdPageData(billingSnapshot.pageSlabs);
    }

    setResetKey((k) => k + 1);
  };
  const handleIsActive = () => {
    setIsActive((prev) => !prev);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setCurrencyOptions(currencyData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!isRowActionTriggered) {
      handleCancel();
    }
  }, [billingActiveTab]);
  const handleCloseChangeDrawer = () => {
    setShowChangeDrawer(false);
  };
  const handleOpenChangeDrawer = async () => {
    try {
      if (selectedData) {
        setShowTooltip(false);
        setShowChangeDrawer(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const currencyData = [
    {
      label: "USD",
      value: "USD",
    },
    {
      label: "INR",
      value: "INR",
    },
  ];
  const handleSearchUser = async (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;

    if (query.startsWith(" ")) return;

    setSelectedUser(null);
    setUserSearchQuery(query);

    const trimmedQuery = query.trim();
    if (trimmedQuery.length < 3) {
      setUserData([]);
      return;
    }

    try {
      const payload = {
        caseInfoId: selectedCaseInfoId,
        searchString: trimmedQuery,
      };
      const response: any = await fetchUerListByCase(payload);
      setUserData(Array.isArray(response.result) ? response.result : []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setUserData([]);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleCurrencyChange = (e: any) => {
    const selectedValue = e.target.value;

    const selectedOption = currencyOptions.find(
      (opt) => String(opt.value) === String(selectedValue),
    );

    setSelectedCurrency(selectedValue);
    setSelectedCurrencyLabel(selectedOption?.label || "");
  };
  const thresholdAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={pageThresholdKey}
      onSelect={(key) => setPageThresholdKey(key as string)}
    />
  );

  const [userRole, setUserRole] = useState("");

  const getloggedInUserRole = async () => {
    try {
      const userRole = await fetcheaderinfo(selectedUser.userId);
      setUserRole(userRole.userroledescription);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getloggedInUserRole();
  }, [selectedUser]);

  const isRecordReviewer = userRole.toLowerCase().includes("record reviewer");

  const isTranscriber = userRole.toLocaleLowerCase().includes("transcriber");

  const shouldDisableCurrency = !isTranscriber;

  const handleSelectUser = (option: any) => {
    setSelectedUser(option);
    setUserSearchQuery("");
    setUserData([]);
    if (isRecordReviewer) {
      setIsInputPages("Output");
    }
  };

  const validateConfiguration = () => {
    const errors = [];

    if (!selectedCurrency || selectedCurrency?.length === 0) {
      errors.push("Currency is mandatory.");
    }
    if (!selectedUser) {
      errors.push("User is mandatory.");
    }
    if (
      rateType == "Fixed" ||
      rateType == "Fixed Per Page" ||
      rateType == "Fixed Per Line"
    ) {
      if (selectedCurrency && !fixedAmount) {
        errors.push("Amount is mandatory.");
      }

      if (selectedCurrency) {
        if (
          fixedAmount === null ||
          fixedAmount === undefined ||
          fixedAmount === "" ||
          Number(fixedAmount) === 0
        ) {
          errors.push("Amount cannot be zero.");
        }
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const parsePageSlabsText = (text: string) => {
    if (!text) return { slabs: [], pageType: "Input" as "Input" | "Output" };

    const rows = text
      .split("|")
      .map((r) => r.trim())
      .filter(Boolean);

    const slabs = rows.map((row) => {
      const [isInput, min, max, rate] = row.split(",");

      return {
        isInputPage: Number(isInput) as 0 | 1,
        min: Number(min),
        max: Number(max),
        rate: Number(rate),
      };
    });

    const pageType = slabs[0]?.isInputPage === 1 ? "Input" : "Output";

    return { slabs, pageType };
  };

  const parseThresholdLineString = (data?: string) => {
    if (!data) return [];

    return data.split("|").map((chunk) => {
      const [min, max, rate] = chunk.trim().split(",");

      return {
        min: Number(min),
        max: Number(max),
        rate: Number(rate),
      };
    });
  };

  const getBillingDetails = async () => {
    try {
      const billingData = await getCaseLevelBillingDetails(
        selectedData.billingCaseConfigId,
      );

      if (billingData) {
        if (billingData.billingForUserFullName) {
          setSelectedUser({
            userId: billingData.userId ?? null, // if available
            tenantId: billingData.tenantId ?? null,
            usfUlNameRole: billingData.billingForUserFullName,
          });
        }

        const getRateType =
          billingData.rateType == "Fixed" && billingData.flatRate > 0
            ? "Fixed"
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage > 0
              ? "Fixed Per Page"
              : billingData.rateType == "Fixed" &&
                  billingData.flatRatePerLine > 0
                ? "Fixed Per Line"
                : billingData.rateType == "PER_PAGE"
                  ? "Per Page"
                  : billingData.rateType == "PER_LINE"
                    ? "Per Line"
                    : "";
        setRateType(getRateType);

        setSelectedCurrency(
          billingData.currencyType ? billingData.currencyType : null,
        );

        const getFixedAmount =
          billingData.rateType == "Fixed" && billingData.flatRate
            ? billingData.flatRate
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage
              ? billingData.flatRatePerPage
              : billingData.rateType == "Fixed" && billingData.flatRatePerLine
                ? billingData.flatRatePerLine
                : "";

        setFixedAmount(getFixedAmount > 0 ? getFixedAmount : "");

        const { slabs, pageType } = parsePageSlabsText(
          billingData.page_slabs_text,
        );

        setIsInputPages(getRateType == "Per Page" ? pageType : "");
        setThresholdPageData(getRateType == "Per Page" ? slabs : []);

        const parsedLine = parseThresholdLineString(
          billingData.line_slabs_text,
        );

        setThresholdLineData(getRateType == "Per Line" ? parsedLine : []);

        setBillingSnapshot({
          rateType: getRateType,
          fixedAmount: billingData.flatRate > 0 ? billingData.flatRate : null,
          pageAmount:
            billingData.flatRatePerPage > 0
              ? billingData.flatRatePerPage
              : null,
          lineAmount:
            billingData.flatRatePerLine > 0
              ? billingData.flatRatePerLine
              : null,
          pageType,
          pageSlabs: slabs,
          lineSlabs: parsedLine,
        });

        setComments(billingData.comments ? billingData.comments : null);

        setCreatedOn(
          billingData.createdDate
            ? formatAppointmentDateTime(billingData.createdDate)
            : "",
        );

        setCreatedBy(
          billingData.createdByName ? billingData.createdByName : "",
        );

        const logData = await getCaseLevelBillingChangeLog(
          selectedData.billingCaseConfigId,
        );

        const filteredLogData = logData?.filter(
          (item: any) =>
            !["modifieddate", "modifiedby"].includes(
              item.fieldName?.toLowerCase(),
            ),
        );

        setChangeLogData(filteredLogData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedData) {
      getBillingDetails();
    }
  }, [selectedData]);

  const applySnapshot = (snapshot: any) => {
    setRateType(snapshot.rateType);

    // clear everything first
    setFixedAmount("");
    setThresholdPageData([]);
    setThresholdLineData([]);
    setIsInputPages("");

    if (snapshot.rateType === "Fixed") {
      setFixedAmount(snapshot.fixedAmount);
    }

    if (snapshot.rateType === "Fixed Per Page") {
      setFixedAmount(snapshot.pageAmount);
    }
    if (snapshot.rateType === "Fixed Per Line") {
      setFixedAmount(snapshot.lineAmount);
    }

    if (snapshot.rateType === "Per Page") {
      setIsInputPages(snapshot.pageType);
      setThresholdPageData(snapshot.pageSlabs);
    }

    if (snapshot.rateType === "Per Line") {
      setThresholdLineData(snapshot.lineSlabs);
    }

    // force table re-init
    setResetKey((k) => k + 1);
    getBillingDetails();
  };

  const validateThreshold = () => {
    const errors = [];
    if (rateType == "Per Page") {
      if (thresholdErrors.length > 0) {
        errors.push(...thresholdErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateLineThreshold = () => {
    const errors = [];

    if (rateType == "Per Line") {
      if (thresholdLineErrors.length > 0) {
        errors.push(...thresholdLineErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };
  const resetData = async () => {
    if (!selectedData?.billingCaseConfigId) {
      handleCancel();
      return;
    }

    if (!billingSnapshot) return;

    setLoading(true);
    applySnapshot(billingSnapshot);
    setLoading(false);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = () => {
    resetData();
    setShowModalNew(false);
  };
  useEffect(() => {
    if (thresholdErrors.length > 0) {
      validateThreshold();
    }
  }, [thresholdErrors]);

  useEffect(() => {
    if (thresholdLineErrors.length > 0) {
      validateLineThreshold();
    }
  }, [thresholdLineErrors]);

  const [billingSnapshot, setBillingSnapshot] = useState<{
    rateType:
      | "Fixed"
      | "Fixed Per Page"
      | "Fixed Per Line"
      | "Per Page"
      | "Per Line"
      | "";
    fixedAmount: string | null;
    pageAmount: string | null;
    lineAmount: string | null;
    pageType: any;
    pageSlabs: any[];
    lineSlabs: any[];
  } | null>(null);

  const handleSave = async () => {
    if (!validateConfiguration()) return;
    setLoading(true);
    try {
      const rateTypeValue =
        rateType === "Fixed" ||
        rateType === "Fixed Per Page" ||
        rateType === "Fixed Per Line"
          ? "Fixed"
          : rateType === "Per Page"
            ? "PER_PAGE"
            : "PER_LINE";

      const payload: any = {
        ...(selectedData?.billingCaseConfigId && {
          billingCaseConfigId: selectedData.billingCaseConfigId,
        }),
        caseInfoId: selectedCaseInfoId,
        userId: selectedUser ? selectedUser.userId : null,
        rateType: rateTypeValue,
        currencyType: selectedCurrency,
        flatRate: rateType === "Fixed" ? fixedAmount : 0,
        flatRatePerPage: rateType == "Fixed Per Page" ? fixedAmount : 0,
        flatRatePerLine: rateType == "Fixed Per Line" ? fixedAmount : 0,
        isPageThresholdAppl: rateType === "Per Page" ? 1 : 0,
        comments,
        isActive: isActive ? 1 : 0,
        modifiedBy: userID,
        createdBy: userID,
        pageSlabsText: rateType === "Per Page" ? formattedStringPerPage : null,
        lineSlabsText: rateType === "Per Line" ? formattedStringPerLine : null,
      };

      const saveBillingConfig = async () => {
        const api = selectedData?.billingCaseConfigId
          ? updateCaseLevelBillingConfig
          : addCaseLevelBillingConfig;
        return api(payload);
      };
      const response = await saveBillingConfig();
      if (response.isSuccess) {
        setSnackbarMessage("Billing Configuration Updated Successfully.");
        setError("success");
        setSnackbarOpen(true);
        if (!selectedData?.billingCaseConfigId && !isBillingAvailable) {
          dispatch(setBillingAvailable(true));
        }
        setTimeout(() => {
          onTabChange();
        }, 500);
      }
    } catch (error) {
      console.error("Error while saving system configuration:", error);
      setSnackbarMessage("An unexpected error occurred.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleBack = () => {
    onCancel("Cancel");
  };
  const handleCancel = () => {
    setSelectedUser(null);
    setUserSearchQuery("");
    setRateType("Fixed");
    setSelectedCurrency("USD");
    setFixedAmount("");
    const { slabs, pageType } = parsePageSlabsText("");
    setIsInputPages(pageType);
    setThresholdPageData(slabs);
    setThresholdLineData([]);
    setComments("");
  };

  const fixedSelected = ["Fixed", "Fixed Per Page", "Fixed Per Line"].includes(
    rateType,
  );

  return (
    <div>
      <Container fluid className="pb-5">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        {configurationAccordion([
          {
            title: "Billing Configuration",
            content: (
              <>
                <Row className="align-items-center mt-3">
                  {/* <div style={{ width: "130px" }}>
                    <Col xs="auto" className="fw-semibold ps-1 ">
                      Billing
                    </Col>
                  </div> */}
                  <Col className="col-md-12 col-xxl-12">
                    <div className="form-floating" ref={dropdownRef}>
                      <input
                        type="text"
                        name="User Name"
                        className="form-control zipcodeDetailsOverlay"
                        placeholder="Search User"
                        maxLength={50}
                        value={
                          selectedUser
                            ? selectedUser.usfUlNameRole
                            : userSearchQuery
                        }
                        onChange={handleSearchUser}
                        autoComplete="off"
                        required
                        disabled={selectedData}
                      />
                      <label>
                        User Name
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      {userData.length > 0 && (
                        <div className="dropdown-results">
                          <ul
                            className="list-group"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {/* Header */}

                            {userData.map((option) => (
                              <li
                                key={option.userId}
                                className="list-group-item d-flex justify-content-between align-items-center"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSelectUser(option)}
                              >
                                <div style={{ width: "2%" }}>
                                  <input
                                    type="radio"
                                    name="location"
                                    checked={
                                      selectedUser?.usfUlNameRole ===
                                      option.usfUlNameRole
                                    }
                                    onChange={() => handleSelectUser(option)}
                                  />
                                </div>
                                <div style={{ width: "98%" }}>
                                  {option.usfUlNameRole}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="align-items-center mt-3 ">
                  <div className="col-md-6 col-xxl-4">
                    <div className="rate-type-wrapper">
                      {/* Fixed */}
                      <div className="rate-type-block adjust_spacingToggle">
                        <div className="rate-type-label">
                          Rate Type (Fixed)
                          <span style={{ color: "#0092d5" }}>
                            {fixedSelected ? " Selected" : ""}
                          </span>
                        </div>

                        <ToggleButtonGroup
                          type="radio"
                          name="rateTypeMain"
                          value={rateType}
                          onChange={handleRateTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="fixed-rate"
                            variant="outline-secondary"
                            value="Fixed"
                            className="px-3"
                          >
                            Fixed
                          </ToggleButton>

                          <ToggleButton
                            id="per-page-main"
                            variant="outline-secondary"
                            value="Fixed Per Page"
                            className="px-3"
                          >
                            Per Page
                          </ToggleButton>

                          <ToggleButton
                            id="per-line-main"
                            variant="outline-secondary"
                            value="Fixed Per Line"
                            className="px-3"
                          >
                            Per Line
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>

                      {/* Pipe */}
                      <div className="rate-type-pipe">||</div>

                      {/* Slab */}
                      <div className="rate-type-block">
                        <div className="rate-type-label">
                          Rate Type (Slab)
                          <span style={{ color: "#0092d5" }}>
                            {!fixedSelected ? " Selected" : ""}
                          </span>
                        </div>

                        <ToggleButtonGroup
                          type="radio"
                          name="rateTypeSlab"
                          value={rateType}
                          onChange={handleRateTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="per-page-slab"
                            variant="outline-secondary"
                            value="Per Page"
                            className="px-3"
                          >
                            Per Page
                          </ToggleButton>

                          <ToggleButton
                            id="per-line-slab"
                            variant="outline-secondary"
                            value="Per Line"
                            className="px-3"
                          >
                            Per Line
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                    </div>
                  </div>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Currency"
                      value={selectedCurrency}
                      options={currencyOptions}
                      onChange={handleCurrencyChange}
                      name="currencyID"
                      required={true}
                    />
                  </Col>
                  {rateType == "Fixed" ||
                  rateType == "Fixed Per Page" ||
                  rateType == "Fixed Per Line" ? (
                    <Col sm={3}>
                      <NumberInput
                        label="Amount"
                        name="amount"
                        value={fixedAmount}
                        onChange={(e) => setFixedAmount(e.target.value)}
                        allowDecimal={true}
                        limit={[8, 2]}
                        showAmountLabel={true}
                        amountLabel={selectedCurrencyLabel}
                      />
                    </Col>
                  ) : null}
                  {rateType === "Per Page" && (
                    <>
                      <Col
                        sm="3"
                        className="fw-semibold ps-1 form-label-fixed d-flex align-items-center adjust_spacingToggle"
                      >
                        Slab Apply on Pages
                        <ToggleButtonGroup
                          type="radio"
                          name="inputPagesType"
                          value={isInputPages}
                          onChange={handlePagesTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="input-page"
                            variant="outline-secondary"
                            value="Input"
                            className="px-3"
                            disabled={!isRecordReviewer}
                          >
                            Input
                          </ToggleButton>

                          <ToggleButton
                            id="output-page"
                            variant="outline-secondary"
                            value="Output"
                            className="px-3"
                            disabled={!isRecordReviewer}
                          >
                            Output
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Col>
                    </>
                  )}
                </Row>

                {rateType == "Per Page" ? (
                  <Row className="align-items-center mt-3">
                    {thresholdAccordion([
                      {
                        title:
                          isInputPages === "Input"
                            ? "Input Page Threshold"
                            : "Output Page Threshold",
                        content: (
                          <ThresholdEditableTable
                            resetKey={resetKey}
                            isInputPages={isInputPages}
                            onChange={setThresholdPageData}
                            onValidationError={setThresholdErrors}
                            value={thresholdPageData}
                          />
                        ),
                      },
                    ])}
                  </Row>
                ) : null}
                {rateType == "Per Line" ? (
                  <Row className="align-items-center mt-3">
                    {thresholdAccordion([
                      {
                        title: "Line Threshold",
                        content: (
                          <ThresholdLineEditable
                            resetKey={resetKey}
                            value={thresholdLineData}
                            onChange={setThresholdLineData}
                            onValidationError={setThresholdLineErrors}
                          />
                        ),
                      },
                    ])}
                  </Row>
                ) : null}
                <Row className="align-items-center mt-3">
                  <Col sm={6} md={4}>
                    <div className="d-flex align-items-center toggle-btn">
                      <span className="me-3 fw-semibold">Status</span>

                      <Form.Check
                        type="switch"
                        id="sort-switch"
                        checked={isActive}
                        onChange={handleIsActive}
                      />
                      <span className="ms-2">
                        {isActive ? "Active" : "In Active"}
                      </span>
                    </div>
                  </Col>
                </Row>
                <Col
                  sm={12}
                  className="mt-3 notemultiline notemultilinerushnote  mb-3"
                >
                  <MultilineTextBox
                    label="Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={100}
                  />
                </Col>
                <Row className="mt-3 mb-3">
                  <Col sm={12} className="d-flex align-items-center">
                    {changeLogData?.length > 0 && selectedData && (
                      <OverlayTrigger
                        show={showTooltip}
                        placement="auto"
                        trigger={["hover", "focus"]}
                        delay={{ show: 200, hide: 100 }}
                        overlay={
                          <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                            Logs
                          </Tooltip>
                        }
                      >
                        <div className="d-flex">
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handleOpenChangeDrawer}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <span className="material-icons">description</span>
                          </Button>
                        </div>
                      </OverlayTrigger>
                    )}

                    {caseUserData?.caseInfoId && (
                      <Button
                        variant="outline-info"
                        className="d-flex align-items-center me-auto btn-text-border"
                        onClick={handleBack}
                      >
                        <span className="material-icons me-1">arrow_back</span>
                        Back
                      </Button>
                    )}

                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCancelButton}
                    >
                      <span className="material-icons me-1">close</span>
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleSave}
                    >
                      <span className="material-icons me-1">save</span>
                      Save
                    </Button>
                  </Col>
                </Row>
              </>
            ),
          },
        ])}

        <ChangeLogDrawer
          title={"Change Log"}
          open={showChangeDrawer}
          onClose={handleCloseChangeDrawer}
          placement="bottom"
          data={changeLogData}
          createdOn={createdOn}
          createdBy={createdBy}
        >
          <BillingDataTable
            headers={BILLINGCASE_CONFIG_CHANGE_LOG}
            rows={changeLogData}
            isLogTable={true}
          />
        </ChangeLogDrawer>
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default CaseBillingAddConfiguration;
